import type { IPosthogSdk } from "./types";

// PosthogSDKWrapper is the local/dev implementation. Flag state lives in
// localStorage so the dev-flag toggle page can flip flags and have the value
// survive page reloads. Capture/identify are console.info stubs — no analytics
// events escape this implementation.
export class PosthogSDKWrapper implements IPosthogSdk {
  private readonly STORAGE_KEY = "tessa_posthog_flags";
  private flagHandlers: Array<() => void> = [];

  init(): Promise<void> {
    return Promise.resolve();
  }

  isFlagEnabled(flagName: string): boolean | undefined {
    const flags = this.getFlags();
    return flags[flagName] ?? false;
  }

  onFeatureFlags(handler: () => void): () => void {
    this.flagHandlers.push(handler);
    // Fire once so the caller gets initial state without waiting for a toggle.
    handler();
    return () => {
      const i = this.flagHandlers.indexOf(handler);
      if (i > -1) this.flagHandlers.splice(i, 1);
    };
  }

  setFlag(flagName: string, isEnabled: boolean): void {
    const flags = this.getFlags();
    flags[flagName] = isEnabled;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(flags));
    this.notifyHandlers();
  }

  identify(id: string, email: string): void {
    console.info("posthog (local)", "identify", id, email);
  }

  capture(event: string, properties?: Record<string, unknown>): void {
    console.info("posthog (local)", "capture", event, properties);
  }

  logout(): void {
    console.info("posthog (local)", "logout");
  }

  private getFlags(): Record<string, boolean> {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  }

  private notifyHandlers(): void {
    this.flagHandlers.forEach((h) => h());
  }
}
